import { apiSlice } from '../../../api/common/apiSlice';
import { ApiTagType } from '../../../constants/apiTagType';
import { FetchDerayahOrdersResponse } from '../../../types/derayah';

export const derayahApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    fetchDerayahOrdersByMadkholOrderId: builder.query<FetchDerayahOrdersResponse, string>({
      query: (madkholOrderId) => ({
        url: `/admin/derayah/orders/${madkholOrderId}`,
        method: 'GET',
      }),
      providesTags: (res, error, madkholOrderId) => [
        ...(res || []).map(({ id }) => ({ type: ApiTagType.DerayahOrder as const, id })),
        { type: ApiTagType.DerayahOrder, id: madkholOrderId },
      ],
    }),
  }),
});

export const { useFetchDerayahOrdersByMadkholOrderIdQuery } = derayahApiSlice;
